"use strict"

import QRCode from 'qrcode'
import subdomains from '@/config/subdomains'

export class GerarQRCode {
  constructor() {}
  static async generate({ company, content }) {
    try {
      const opts = subdomains.infos({ subdomain: company }).qrcodeOptions
      return await QRCode.toDataURL(content, opts)
    }
    catch (err) {
      console.error(err)
    }
  }
}